<p-toast></p-toast>
<p-panel header="Roads">
  <ng-template #icons>
    <div class="flex gap-2">

      <!-- Add Button -->
      <p-button icon="pi pi-plus" label="Add" severity="primary" (onClick)="addNew()" [disabled]="loading()" outlined>
      </p-button>

      <!-- Edit Button -->
      <p-button icon="pi pi-pencil" label="Edit" severity="secondary" (onClick)="editRoad()"
        [disabled]="selectedRoads().length !== 1 || loading()" outlined>
      </p-button>

      <!-- Delete Button -->
      <p-button icon="pi pi-trash" [label]="deleteButtonLabel()" severity="danger" (onClick)="deleteRoad()"
        [disabled]="selectedRoads().length === 0 || loading()" outlined>
      </p-button>

      <!-- Refresh Button -->
      <p-button icon="pi pi-refresh" label="Refresh" severity="secondary" (onClick)="refreshRoads()"
        [disabled]="loading()" outlined>
      </p-button>

      <!-- History Button -->
      <p-button icon="pi pi-history" label="History" severity="secondary" (onClick)="showHistory()"
        [disabled]="loading() || selectedRoads().length !== 1" outlined>
      </p-button>

    </div>
  </ng-template>
  <ng-template #content>
    <!-- Search Panel -->
    <div class="mb-3">
      <label for="roadSearch" class="block text-sm font-medium mb-1">Search by Road Name or Road
        Code</label>
      <div class="flex items-center gap-2">
        <div class="flex-1">
          <p-iconfield iconPosition="left">
            <p-inputicon>
              <i class="pi pi-search"></i>
            </p-inputicon>
            <input id="roadSearch" pInputText type="text" [ngModel]="keywords"
              (ngModelChange)="onFilter($event)" placeholder="Enter search terms..."
              autocomplete="off" />
          </p-iconfield>
        </div>

        <p-button *ngIf="keywords.trim()" icon="pi pi-times" label="Clear" severity="secondary" size="small"
          (onClick)="clearFilter()" outlined>
        </p-button>
      </div>
    </div>

    <p-divider></p-divider>
    <p-table [value]="(roads() || [])" [totalRecords]="(totalRecords() || 0)" [paginator]="true" [rows]="rows"
      [first]="first" [lazy]="true" [loading]="loading()" [loadingIcon]="'pi pi-spin pi-cog'"
      [tableStyle]="{ 'min-width': '30rem' }" [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} roads" paginatorDropdownAppendTo="body" [rowsPerPageOptions]="[10, 25, 50]"
      (onPage)="onPage($event)" selectionMode="multiple" [selection]="selectedRoads()"
      (selectionChange)="selectedRoads.set($event)" dataKey="id" size="small">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 3rem">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th>Road Name</th>
          <th>Road Code</th>
          <th>MYInfra</th>
          <th>MARRIS ID</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-road>
        <tr [pSelectableRow]="road">
          <td>
            <p-tableCheckbox [value]="road"></p-tableCheckbox>
          </td>
          <td>{{ road.road_name }}</td>
          <td>{{ road.road_code }}</td>
          <td>{{ road.myinfra_id }}</td>
          <td>{{ road.marris_id }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5" class="text-center p-4">No roads found</td>
        </tr>
      </ng-template>
    </p-table>
  </ng-template>
</p-panel>

<p-confirmDialog></p-confirmDialog>

<p-dialog [visible]="dialogVisible()" (visibleChange)="dialogVisible.set($event)" [modal]="true" [draggable]="false"
  [resizable]="false" [closable]="false" [dismissableMask]="true" [closeOnEscape]="true" [style]="{width: '450px'}">
  <ng-template #header>
    <h3 class="text-lg font-medium">{{ isEditMode() ? 'Edit Road' : 'Add Road' }}</h3>
  </ng-template>

  <div class="flex flex-col gap-4 py-2">
    <div class="flex flex-col gap-2">
      <label for="roadName" class="font-medium">Road Name</label>
      <input id="roadName" type="text" pInputText [ngModel]="roadName()" (ngModelChange)="roadName.set($event)"
        placeholder="Enter road name" class="w-full">
    </div>

    <div class="flex flex-col gap-2">
      <label for="roadCode" class="font-medium">Road Code</label>
      <input id="roadCode" type="text" pInputText [ngModel]="roadCode()" (ngModelChange)="roadCode.set($event)"
        placeholder="Enter road code" class="w-full">
    </div>

    <div class="flex flex-col gap-2">
      <label for="myinfraId" class="font-medium">MYInfra</label>
      <input id="myinfraId" type="text" pInputText [ngModel]="myinfraId()" (ngModelChange)="myinfraId.set($event)"
        placeholder="Enter MYInfra ID" class="w-full">
    </div>

    <div class="flex flex-col gap-2">
      <label for="marrisId" class="font-medium">MARRIS ID</label>
      <input id="marrisId" type="text" pInputText [ngModel]="marrisId()" (ngModelChange)="marrisId.set($event)"
        placeholder="Enter MARRIS ID" class="w-full">
    </div>
  </div>

  <ng-template pTemplate="footer">
    <p-button label="Cancel" icon="pi pi-times" (onClick)="closeDialog()" [disabled]="savingRoad()"
      styleClass="p-button-text">
    </p-button>
    <p-button [label]="isEditMode() ? 'Update' : 'Save'" icon="pi pi-check" (onClick)="saveRoad()"
      [disabled]="savingRoad()" [loading]="savingRoad()">
    </p-button>
  </ng-template>
</p-dialog>

<app-asset-history-dialog
  [(visible)]="historyVisible"
  [resourceName]="auditResourceName"
  [recordId]="historyRecordId"
  [recordLabel]="historyRecordLabel">
</app-asset-history-dialog>
